
!function(){

    document.querySelectorAll('[data-modal-button]').forEach(function(node){
        node.addEventListener('click', function(e){
            let modalContentNodeID = this.dataset.modalButton;
            let modalContentNode = document.querySelector(modalContentNodeID)
            let modalTitle = modalContentNode.dataset.modalTitle;
            let content = modalContentNode.innerHTML;
            document.querySelector('#modal-default .modal-title').innerHTML = modalTitle; 
            document.querySelector('#modal-default .modal-body').innerHTML = content; 
        })
    })
}();